import { ReactElement, useMemo, memo } from 'react';
import { Stack, Typography } from '@mui/material';

import { pluralize } from '~utils/commons';

interface DashboardVariantV2CarrierZoneSaturationTableZoneInfoCellProps {
  driversCount: number;
  zoneName: string;
}

const DashboardVariantV2CarrierZoneSaturationTableZoneInfoCell = ({
  driversCount,
  zoneName,
}: DashboardVariantV2CarrierZoneSaturationTableZoneInfoCellProps): ReactElement => {
  const driversText = useMemo(
    () =>
      pluralize({
        singular: 'chofer',
        plural: 'choferes',
        count: driversCount,
        includeCount: true,
      }),
    [driversCount],
  );

  return (
    <Stack>
      <Typography variant="caption" color="text.primary" fontWeight="bold">
        {zoneName}
      </Typography>

      <Typography variant="caption" color="text.secondary">
        {`${driversText} de distribución`}
      </Typography>
    </Stack>
  );
};

export default memo(DashboardVariantV2CarrierZoneSaturationTableZoneInfoCell);
